export default __webpack_public_path__ + "static/generic-0bd218592b37cf206eb6bb81404b14a7.jpg";